/**
 * Deal-specific form validators.
 *
 * Validates DEAL campaign-specific fields: percent of original deal price guardrail.
 * Extracted from formValidationUtils for single-responsibility.
 *
 * @module dealValidation
 */

import { UseCampaignFormResult } from 'src/hooks/useCampaignForm/useCampaignForm';
import { parseOptionalNumber } from 'src/utils/helpers';
import { FieldErrors } from '../formValidationUtils';

// ============================================================================
// Public API
// ============================================================================

export function validateDeal(form: UseCampaignFormResult, f: FieldErrors): void {
    const dealPercent = parseOptionalNumber(form.dealPercentOfOriginalDealPrice);
    if (dealPercent == null || dealPercent < 0 || dealPercent > 100) {
        f.dealPercentOfOriginalDealPrice = { key: 'deal_percent_range' };
    }
}
